import {Injectable} from '@angular/core';

@Injectable()
export class AlertService {
    constructor() {
    }


}



// WEBPACK FOOTER //
// ./src/app/common/services/alert.service.ts